import { render, staticRenderFns } from "./CadastroFormaPagamento.vue?vue&type=template&id=6d4ebd16"
import script from "./CadastroFormaPagamento.vue?vue&type=script&lang=js"
export * from "./CadastroFormaPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports